import React, { useContext } from 'react';

import type { ITableConsumerState } from './ITableConsumerState';

export const TableContext = React.createContext<
    ITableConsumerState<any, any> | undefined
>(undefined);

export function useTableContext(): ITableConsumerState<any, any> {
    const context = useContext(TableContext);
    if (!context) {
        throw new Error(
            'useTableContext must be used within a TableContext.Provider',
        );
    }
    return context;
}
